<section class="page">
  <spw-message
    *ngIf="successMessage"
    [messageTitle]="'Succès'"
    variant="success"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ successMessage }}
  </spw-message>
  <spw-message
    *ngIf="errorMessage"
    [messageTitle]="'Erreur'"
    variant="alert"
    [isDismissable]="true"
    [dismissableText]="'Fermer'"
  >
    {{ errorMessage }}
  </spw-message>

  <div class="loading" *ngIf="isLoading">
    <spw-loading></spw-loading>
  </div>

  <div *ngIf="!isLoading && home" class="home">


    <spw-hero variant="photo" image-src="https://images.unsplash.com/photo-1556742393-d75f468bfcb0" image-alt="Attribut alt" surface="light" alignment="left">
    <h1 class="spw-ds-typography-heading-01 mb-3">Plateau {{ home.plateau.code }}</h1>

    <p class="hero-platform-desc">
      CoffeeClub organise les achats de café de votre plateau en équipe. Chaque buveur est désigné à tour de rôle pour acheter le prochain paquet selon sa consommation et sa présence au bureau. Dès que le café est acheté, confirmez-le ici pour mettre le planning à jour.
    </p>

    <span slot="description" *ngIf="home.plateau.batiment || home.plateau.etage">
      {{ home.plateau.batiment }}<span *ngIf="home.plateau.batiment && home.plateau.etage"> · </span>
      <span *ngIf="home.plateau.etage">Étage {{ home.plateau.etage }}</span>
    </span>

    <div class="hero-buttons">
      <div class="hero-button-group">
        <spw-button
          variant="primary"
          [disabled]="isConfirming || !home.actions.canConfirmPurchase"
          (click)="requestConfirmPurchase()"
        >
          {{ isConfirming ? 'Confirmation...' : 'Café acheté !' }}
        </spw-button>
        <div class="info-tooltip">
          <svg class="info-tooltip__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
          </svg>
          <span class="info-tooltip__text">Cliquez ici lorsque vous avez acheté du café pour confirmer l'achat et mettre le planning à jour. Disponible uniquement pour le responsable actuel.</span>
        </div>
      </div>

      <div class="hero-button-group">
        <spw-button variant="secondary" [disabled]="isWarningSending" (click)="requestConfirmWarning()">
          {{ isWarningSending ? 'Envoi...' : "Warning plus d'café !" }}
        </spw-button>
        <div class="info-tooltip">
          <svg class="info-tooltip__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
          </svg>
          <span class="info-tooltip__text">Signalez au responsable actuel que le stock de café est épuisé ou presque vide. Un e-mail de rappel lui sera envoyé.</span>
        </div>
      </div>
    </div>
  </spw-hero>

    <!-- Hero Section Old
    <spw-hero variant="grey" surface="dark" alignment="left">
      <span slot="label">Plateau</span>
      <span slot="title">{{ home.plateau.code }}</span>
      <span slot="description" *ngIf="home.plateau.batiment || home.plateau.etage">
        {{ home.plateau.batiment }}<span *ngIf="home.plateau.batiment && home.plateau.etage"> · </span>
        <span *ngIf="home.plateau.etage">Étage {{ home.plateau.etage }}</span>
      </span>
      <div slot="actions" class="hero-actions">
        <spw-button
          *ngIf="home.actions.canConfirmPurchase"
          variant="primary"
          [disabled]="isConfirming"
          (click)="confirmPurchase()"
        >
          {{ isConfirming ? 'Confirmation...' : 'Café acheté !' }}
        </spw-button>
        <spw-button variant="secondary" [disabled]="isWarningSending" (click)="sendWarning()">
          {{ isWarningSending ? 'Envoi...' : "Warning plus d'café !" }}
        </spw-button>
      </div>
    </spw-hero>
-->
    <!-- Alert Stock -->
    <spw-message
      *ngIf="shouldShowStockAlert()"
      [messageTitle]="getStockAlertTitle()"
      variant="alert"
      [isDismissable]="false"
    >
      {{ getStockAlertMessage() }}
    </spw-message>

    <!-- KPI Grid -->
    <div class="kpi-grid">
      <div class="kpi-card kpi-card--users">
        <div class="kpi-card__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
          </svg>
        </div>
        <div class="kpi-card__content">
          <span class="kpi-card__value">{{ home.stats.nbBuveursActifs }}</span>
          <span class="kpi-card__label">Buveurs actifs</span>
        </div>
      </div>

      <div class="kpi-card kpi-card--consumption">
        <div class="kpi-card__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2 21h18v-2H2v2zm18-10v-1c0-1.1-.9-2-2-2V5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v3c-1.1 0-2 .9-2 2v1c-1.1 0-2 .9-2 2v4h20v-4c0-1.1-.9-2-2-2zm-2-5H8V6h10v5z"/>
          </svg>
        </div>
        <div class="kpi-card__content">
          <span class="kpi-card__value">{{ home.stats.tassesParJourPlateau | number: '1.0-1' }}</span>
          <span class="kpi-card__label">Tasses / jour</span>
        </div>
      </div>

      <div class="kpi-card kpi-card--frequency">
        <div class="kpi-card__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z"/>
          </svg>
        </div>
        <div class="kpi-card__content">
          <span class="kpi-card__value" *ngIf="home.stats.joursParPaquet !== null; else noFrequency">
            {{ home.stats.joursParPaquet | number: '1.0-1' }}j
          </span>
          <ng-template #noFrequency>
            <span class="kpi-card__value">—</span>
          </ng-template>
          <span class="kpi-card__label">Jours / paquet</span>
        </div>
      </div>

      <div
        class="kpi-card"
        [class.kpi-card--stock-ok]="getStockStatus() === 'ok'"
        [class.kpi-card--stock-warning]="getStockStatus() !== 'ok'"
      >
        <div class="kpi-card__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4h16v3z"/>
          </svg>
        </div>
        <div class="kpi-card__content">
          <spw-tag
            [variant]="getStockTagVariant()"
            size="small"
            surface="light"
          >
            {{ getStockLabel() }}
          </spw-tag>
          <span class="kpi-card__label">État du stock</span>
        </div>
      </div>
    </div>

    <!-- Info Cards Section -->
    <div class="info-section">
      <div class="info-card info-card--responsible">
        <div class="info-card__header">
          <svg class="info-card__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
          </svg>
          <span class="info-card__title">Responsable actuel</span>
        </div>
        <div class="info-card__body" *ngIf="home.currentResponsible">
          <strong class="info-card__name">{{ home.currentResponsible.prenom }} {{ home.currentResponsible.nom }}</strong>
          <spw-tag variant="green" size="small" surface="light">En charge</spw-tag>
        </div>
        <div class="info-card__body" *ngIf="!home.currentResponsible">
          <span class="info-card__empty">Aucun responsable assigné</span>
        </div>
      </div>

      <div class="info-card info-card--purchase">
        <div class="info-card__header">
          <svg class="info-card__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
          </svg>
          <span class="info-card__title">Dernier achat</span>
        </div>
        <div class="info-card__body">
          <ng-container *ngIf="!isLastPurchaseLoading; else loadingLastPurchase">
            <ng-container *ngIf="lastPurchase; else noLastPurchase">
              <strong class="info-card__name">{{ lastPurchase.buyer.prenom }} {{ lastPurchase.buyer.nom }}</strong>
              <span class="info-card__date">{{ lastPurchase.purchasedAt | date: 'dd MMM yyyy à HH:mm' }}</span>
            </ng-container>
          </ng-container>
          <ng-template #loadingLastPurchase>
            <span class="info-card__loading">Chargement...</span>
          </ng-template>
          <ng-template #noLastPurchase>
            <span class="info-card__empty">Aucun achat enregistré</span>
          </ng-template>
        </div>
        <div class="info-card__footer">
          <spw-button variant="tertiary" (click)="openHistoryModal()">
            Voir l'historique
          </spw-button>
        </div>
      </div>
    </div>

    <!-- Planning Section -->
    <div class="planning">
      <div class="planning__header">
        <h2 class="planning__title">Prochains achats</h2>
      </div>
      <spw-table>
        <spw-table-head>
          <spw-table-row>
            <spw-table-header>Responsable</spw-table-header>
            <spw-table-header>Statut</spw-table-header>
            <spw-table-header>Date suggérée</spw-table-header>
          </spw-table-row>
        </spw-table-head>
        <spw-table-body>
          <spw-table-row *ngFor="let item of home.planningPreview; let index = index" [class.planning-row--current]="isCurrentResponsibleTag(item, index)">
            <spw-table-cell>
              <div class="planning-user">
                <span class="planning-user__name" [attr.title]="getResponsibleTooltip(item)">
                  {{ item.prenom }} {{ item.nom }}
                </span>
                <spw-tag *ngIf="item.isCurrentUser" variant="blue" size="small" surface="light">Vous</spw-tag>
              </div>
            </spw-table-cell>
            <spw-table-cell>
              <div class="planning-status">
                <spw-tag
                  [variant]="isCurrentResponsibleTag(item, index) ? 'green' : 'grey'"
                  size="small"
                  surface="light"
                >
                  {{ isCurrentResponsibleTag(item, index) ? 'Responsable actuel' : 'À venir' }}
                </spw-tag>
                <spw-button
                  *ngIf="item.isCurrentUser && home.actions.canConfirmPurchase"
                  variant="primary"
                  size="small"
                  [disabled]="isConfirming"
                  (click)="confirmPurchase()"
                >
                  {{ isConfirming ? '...' : 'Confirmer' }}
                </spw-button>
              </div>
            </spw-table-cell>
            <spw-table-cell>
              <span *ngIf="item.suggestedPurchaseAt; else noSuggestedDate" class="planning-date">
                {{ item.suggestedPurchaseAt | date: 'dd MMM yyyy' }}
              </span>
              <ng-template #noSuggestedDate>
                <span class="planning-date planning-date--empty">À définir</span>
              </ng-template>
            </spw-table-cell>
          </spw-table-row>
        </spw-table-body>
      </spw-table>
    </div>
  </div>

  <!-- Confirmation : Café acheté -->
  <div class="confirm-overlay" *ngIf="showConfirmPurchase" (click)="cancelConfirmPurchase()">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <div class="confirm-modal__icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>
        </svg>
      </div>
      <p class="confirm-modal__title">Confirmer l'achat de café ?</p>
      <p class="confirm-modal__text">Cette action va enregistrer votre achat et mettre à jour le planning du plateau. Êtes-vous certain de vouloir continuer ?</p>
      <div class="confirm-modal__actions">
        <spw-button variant="secondary" (click)="cancelConfirmPurchase()">Non, annuler</spw-button>
        <spw-button variant="primary" (click)="confirmPurchase()">Oui, confirmer</spw-button>
      </div>
    </div>
  </div>

  <!-- Confirmation : Warning -->
  <div class="confirm-overlay" *ngIf="showConfirmWarning" (click)="cancelConfirmWarning()">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <div class="confirm-modal__icon confirm-modal__icon--warning">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
        </svg>
      </div>
      <p class="confirm-modal__title">Envoyer un warning café ?</p>
      <p class="confirm-modal__text">Un e-mail de rappel sera envoyé au responsable actuel pour l'alerter que le stock de café est épuisé. Êtes-vous certain de vouloir continuer ?</p>
      <div class="confirm-modal__actions">
        <spw-button variant="secondary" (click)="cancelConfirmWarning()">Non, annuler</spw-button>
        <spw-button variant="primary" (click)="sendWarning()">Oui, envoyer</spw-button>
      </div>
    </div>
  </div>

  <div class="modal-backdrop" *ngIf="isHistoryOpen" (click)="closeHistoryModal()">
    <div class="modal" (click)="$event.stopPropagation()">
      <div class="modal__header">
        <h2 class="modal__title">Historique des achats</h2>
        <spw-button variant="tertiary" size="small" (click)="closeHistoryModal()">Fermer</spw-button>
      </div>
      <spw-message
        *ngIf="historyErrorMessage"
        [messageTitle]="'Erreur'"
        variant="alert"
        [isDismissable]="true"
        [dismissableText]="'Fermer'"
      >
        {{ historyErrorMessage }}
      </spw-message>
      <div class="loading" *ngIf="isHistoryLoading">
        <spw-loading></spw-loading>
      </div>
      <div *ngIf="!isHistoryLoading" class="history">
        <spw-table>
          <spw-table-head>
            <spw-table-row>
              <spw-table-header>Date</spw-table-header>
              <spw-table-header>Acheteur</spw-table-header>
            </spw-table-row>
          </spw-table-head>
          <spw-table-body>
            <spw-table-row *ngFor="let item of historyPurchases">
              <spw-table-cell>{{ item.purchasedAt | date: 'dd/MM/yyyy HH:mm' }}</spw-table-cell>
              <spw-table-cell>{{ item.buyer.prenom }} {{ item.buyer.nom }}</spw-table-cell>
            </spw-table-row>
          </spw-table-body>
        </spw-table>
        <div class="history__actions" *ngIf="historyHasMore">
          <spw-button variant="secondary" [disabled]="isHistoryLoadingMore" (click)="loadHistory(false)">
            {{ isHistoryLoadingMore ? 'Chargement...' : 'Charger plus' }}
          </spw-button>
        </div>
      </div>
    </div>
  </div>
</section>
